<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; margin: 2vh auto auto;">

    <!-- PAGINA PRINCIPAL -->
    <div *ngIf="!showingDaliData && !showingSensorData">

      <!-- NEW UPPER BAR -->
      <div class="upperRow">
        <div class="filterRow">
          <div *ngIf="userService.getPermiso() == 'Administrador'" class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get('devices.project')}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectProyecto($event.value)" [(ngModel)]="selectedProyecto">
              <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
              <mat-option [ngClass]="{'blueback': proyecto != undefined && selectedProyecto != undefined && selectedProyecto.idProyecto === proyecto.idProyecto}"
                          class="textS" *ngFor="let proyecto of proyectos"
                          [value]="proyecto">{{proyecto.nombre}}</mat-option>
            </mat-select>
          </div>

          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get('devices.floorplan')}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectPlano($event.value)" [(ngModel)]="selectedPlano">
              <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
              <mat-option [ngClass]="{'yeback': plano != undefined && selectedProyecto != undefined && selectedProyecto.idProyecto == plano.idProyecto,
              'blueback': plano != undefined && selectedPlano != undefined && selectedPlano.idPlano === plano.idPlano}"
                          class="textS" *ngFor="let plano of planos"
                          [value]="plano">{{plano.nombre}}</mat-option>
            </mat-select>
          </div>
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get('devices.zone')}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectZona($event.value)" [(ngModel)]="selectedZona">
              <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
              <mat-option [ngClass]="{'yeback': zonas != undefined && selectedPlano != undefined && selectedPlano.idPlano === zona.idPlano,
              'blueback': zona != undefined && selectedZona != undefined && selectedZona.id === zona.id}"
                          class="textS" *ngFor="let zona of zonas" [value]="zona">{{zona.nombre}}</mat-option>
            </mat-select>
          </div>
        </div>

        <div class="optionsButtonRow">
          <div (click)="openOptions()" class="optionsButton">
            <span class="material-icons-outlined textXXM optionsButtonIcon centerVert">
              more_horiz
            </span>
          </div>
        </div>
      </div>

      <!-- LUMINARIAS -->
      <div class="row deviceSection">

        <!-- SEARCHER INPUT -->
        <div class="col searcherLuminariesDiv" *ngIf="luminariasOpen">
          <span class="material-icons-outlined textXXM centerVert searcherLuminariesIcon" style="color: white; width: 15%">
            search
          </span>
          <div class="searcherLuminariesControls">
            <input [(ngModel)]="searcherLuminarias" type="text" class="textS+ searcherInput"
                   placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherLuminariasFunc()" maxlength="50">
            <button *ngIf="canManageLuminaryDeletes()" class="deleteSearchedLuminariesButton textS+" [disabled]="!canDeleteFilteredLuminaries()"
                    [matTooltip]="this.localiser.get('devices.delete.deleteSearchResults')" [matTooltipPosition]="'below'"
                    (click)="deleteFilteredLuminaries()">
              <span class="material-icons-outlined textM deleteSearchedLuminariesIcon">delete</span>
            </button>
          </div>
        </div>

        <!-- PAGINATION LUMS -->
        <div class="paginationDiv" *ngIf="luminariasOpen">
          <div style="width: 25%; margin-right: 5%">
            <mat-progress-spinner *ngIf="loadingLums" class="spinnerBar centerVert" mode="indeterminate" diameter="30"></mat-progress-spinner>
          </div>
          <div class="row" style="width: 70%; display: contents">
            <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
              [ngClass]="{disabled: actualPage == 1}">
                navigate_before
              </span>
            </div>
            <div class="col" style="padding: 0">
              <input type="number" class="inputPagination textXM centerVert" [(ngModel)]="this.actualPage" (ngModelChange)="changePageByNumber($event)"
              (change)="outInputChangePageByNumber($event)">
            </div>
            <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabled: isLastPage()}">
                navigate_next
              </span>
            </div>
          </div>
        </div>

        <!-- GRID VIEW -->
        <div class="col gridViewDiv" *ngIf="luminariasOpen" (click)="changeGridView()" [ngClass]="{selectedGridView: gridView}">
          <span class="material-icons-outlined textXM centerVert cursorPointer"
          [ngClass]="{selectedGridViewSpan: gridView, unselectedGridViewSpan: !gridView}">
            grid_view
          </span>
        </div>

        <!-- FILTER LUMS -->
        <div class="col filterLuminariesDiv" *ngIf="luminariasOpen">
          <span *ngIf="isAnyLumFilterSelected()" (click)="unselectAllLumFilters() "class="material-icons-outlined textXM centerVert cursorPointer unselectAllFilter">
            hide_source
          </span>
          <span *ngIf="!isAnyLumFilterSelected()" class="material-icons-outlined textXM centerVert unselectHideAllFilter">
            hide_source
          </span>
          <span (click)="openLuminariasFilter()" *ngIf="!luminariasFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            manage_search
          </span>
          <span (click)="openLuminariasFilter()" *ngIf="luminariasFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            close
          </span>
          <div *ngIf="luminariasFilterOpen" class="filterLuminariesPanel">

            <!-- GW FILTER LUMS -->
            <div class="row rowFilterSelector" style="height: 25%">
              <div class="col-9">
                <h3 class="textS+ textFilterSelector">{{this.localiser.get('devices.gatewayFilter')}}</h3>
                <mat-select class="upperButton textS" (selectionChange)="selectGWFilterLum($event.value)" [(ngModel)]="selectedGWFilterLum">
                  <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
                  <mat-option class="textS" *ngFor="let gw of this.getGWsByFilteredLums()"
                              [value]="gw">{{gw}}</mat-option>
                </mat-select>
              </div>
              <div class="col-3">
                <span *ngIf="selectedGWFilterLum != undefined" (click)="selectGWFilterLum(undefined) "class="material-icons-outlined textXM centerVert cursorPointer colorFilterSelector">
                  hide_source
                </span>
                <span *ngIf="selectedGWFilterLum == undefined" class="material-icons-outlined textXM centerVert colorHideFilterSelector">
                  hide_source
                </span>
              </div>
            </div>

            <!-- VERSION FIRMWARE FILTER LUMS -->
            <div class="row rowFilterSelector" style="height: 25%">
              <div class="col-9">
                <h3 class="textS+ textFilterSelector">{{this.localiser.get('devices.firmwareVersionFilter')}}</h3>
                <mat-select class="upperButton textS" (selectionChange)="selectFirmwareVersionFilterLum($event.value)" [(ngModel)]="selectedFirmwareVersionFilterLum">
                  <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
                  <mat-option class="textS" *ngFor="let fw of this.getFirmwareVersionByFilteredLums()"
                              [value]="fw">{{fw}}</mat-option>
                </mat-select>
              </div>
              <div class="col-3">
                <span *ngIf="selectedFirmwareVersionFilterLum != undefined" (click)="selectFirmwareVersionFilterLum(undefined) "class="material-icons-outlined textXM centerVert cursorPointer colorFilterSelector">
                  hide_source
                </span>
                <span *ngIf="selectedFirmwareVersionFilterLum == undefined" class="material-icons-outlined textXM centerVert colorHideFilterSelector">
                  hide_source
                </span>
              </div>
            </div>

            <!-- TOGGLES FILTER LUMS -->
            <div class="row rowFilterSelector" style="height: 34%">

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.emergencies')}}</h3>
                </div>
                <div class="row marginAuto" style="height: 40%">
                  <mat-slide-toggle [checked]="selectedEmergenciesFilterLum" (change)="setEmergenciesFilterLum($event.checked)" class="marginAuto">
                    <h3 *ngIf="selectedEmergenciesFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selectedEmergenciesFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.presenceSensor')}}</h3>
                </div>
                <div class="row" style="height: 40%">
                  <mat-slide-toggle [checked]="selectedPresenceSensorsFilterLum" (change)="setPresenceSensorsFilterLum($event.checked)" class="marginAuto">
                    <h3 *ngIf="selectedPresenceSensorsFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selectedPresenceSensorsFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.420Sensor')}}</h3>
                </div>
                <div class="row" style="height: 40%">
                  <mat-slide-toggle [checked]="selected420SensorsFilterLum" (change)="set420SensorsFilterLum($event.checked)" class="marginAuto">
                    <h3 *ngIf="selected420SensorsFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selected420SensorsFilterLum" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- LUM LIST -->
        <div (click)="openLuminarias()" class="deviceHeader col" [ngClass]="{'headerCollapsed': !luminariasOpen}">
          <h1 class="centerVert textXXM">{{this.localiser.get("devices.luminaries")}}</h1>
        </div>
        <div class="deviceTable" *ngIf="luminariasOpen">
          <!-- TABLE INFO DEVICES -->
          <table style="width:100%; white-space: nowrap" *ngIf="!gridView">
            <tr class="bottom-border fixHeaderTable">
              <!-- BLINK LUM -->
              <th class="separator"></th>
              <th *ngIf="user.getPermiso() != 'Ateneo'" class="separator">{{this.localiser.get("devices.edit")}}</th>
              <th (click)="changeOrderLums('nombre', 'string')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.name")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'nombre'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'nombre' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'nombre' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th (click)="changeOrderLums('idPlano', 'string')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.floorplan")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'idPlano'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'idPlano' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'idPlano' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>

              <th (click)="changeOrderLums('idZona', 'string')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.zone")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'idZona'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'idZona' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'idZona' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>

              <th (click)="changeOrderLums('estadoConfirmacionRegla', 'number')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.rule.status")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'estadoConfirmacionRegla'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'estadoConfirmacionRegla' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'estadoConfirmacionRegla' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>

              <th (click)="changeOrderLums('time_LAST_COM', 'number')" colspan="2" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.lastCommunication")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'time_LAST_COM'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'time_LAST_COM' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'time_LAST_COM' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th class="separator">ID</th>
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("fade.groups.gateway")}}</th>

              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("fade.groups.main.gateway.id")}}</th>
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("fade.groups.main.gateway.confirmed")}}</th>
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("fade.groups.getHubsMap")}}</th>
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("devices.peripherals.get")}}</th>

              <th>{{this.localiser.get("devices.version")}}</th>
              <th class="separator" [matTooltip]="this.localiser.get('devices.versionConfirmedTooltip')"
                  [matTooltipPosition]="'above'">{{this.localiser.get("devices.versionConfirmed")}}</th>
              <th (click)="changeOrderLums('rssi', 'number')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">RSSI</span>
                  <span *ngIf="orderVariableLum[0] != 'rssi'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'rssi' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'rssi' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th class="separator">{{this.localiser.get("devices.serialNumber")}}</th>
              <th (click)="changeOrderLums('fechaInstalacion', 'number')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.installationDate")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'fechaInstalacion'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'fechaInstalacion' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'fechaInstalacion' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th class="separator">{{this.localiser.get("devices.emergencies")}}</th>
              <th class="separator">{{this.localiser.get("devices.presenceSensor")}}</th>
              <th class="separator">{{this.localiser.get("devices.420Sensor")}}</th>
              <th class="separator">{{this.localiser.get("devices.modelLed")}}</th>
              <th class="separator">{{this.localiser.get("devices.lux")}}</th>
              <th *ngIf="user.getPermiso() != 'Ateneo'" class="separator">{{this.localiser.get("devices.daliData")}}</th>
              <!-- DELETE LUM -->
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator"></th>
            </tr>

            <!-- ROWS -->
            <tr [ngClass]="{'luminariaSelected': selectedLuminariaByFloorplan != undefined && luminaria.idDispositivo == selectedLuminariaByFloorplan}"
                *ngFor="let luminaria of luminarias">
              <td class="separator" style="width: 30px">
               <span class="material-icons-outlined textS+ verticalAlign" style="cursor: pointer"
                     (click)="blinkLuminaire(luminaria.idDispositivo)">wb_iridescent</span>
              </td>
              <td *ngIf="user.getPermiso() != 'Ateneo'" class="separator">
                <span class="material-icons-outlined textXM verticalAlign" style="cursor: pointer"
                      (click)="editLuminaria(luminaria)">edit</span>
              </td>
              <td class="separator">{{luminaria.nombre}}</td>
              <td class="separator" (click)="selectPlano(getPlanoModelById(luminaria.idPlano))"
                  [ngClass]="{link: this.getPlanoModelById(luminaria.idPlano) != undefined}">
                {{getPlanoNombreById(luminaria.idPlano)}}
              </td>
              <td class="separator" (click)="selectZona(getZonaModelById(luminaria.idZona))"
                  [ngClass]="{link: this.getZonaModelById(luminaria.idZona) != undefined}">
                {{getZonaNombreById(luminaria.idZona)}}
              </td>

              <td class="separator">
                {{getTextoEstadoConfirmacionRegla(luminaria.estadoConfirmacionRegla)}}
              </td>

              <!-- Last Communication -->
              <td class="separator">
                <div matTooltip="{{lastCommunicationTooltip(luminaria)}}" [matTooltipPosition]="'above'">
                  <div class="emergency-px marginAuto" [ngClass]="{'green': getLumCommunicating(luminaria) == 0,
                    'orange': getLumCommunicating(luminaria) == 1}">
                  </div>
                </div>
              </td>
              <td *ngIf="luminaria.time_LAST_COM <= 0" class="separator">
                {{this.localiser.get("devices.noData")}}
              </td>
              <td *ngIf="luminaria.time_LAST_COM > 0" class="separator">
                  {{luminaria.time_LAST_COM_II}}
              </td>
              <td class="separator">{{luminaria.idDispositivo}}</td>

              <td *ngIf="user.getPermiso() !== 'Ateneo' && user.getPermiso() !== 'Configuración'" class="separator">
                {{ getGatewayDisplayName(luminaria.idConcentradorPpal, luminaria.idConcentradorPpalNombre) }}
              </td>

              <td *ngIf="user.getPermiso() !== 'Ateneo' && user.getPermiso() !== 'Configuración'" class="separator">
                {{ getGatewayDisplayName(luminaria.hubPpal, luminaria.hubPpalNombre) }}
              </td>

              <td *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{getLabelHubConfirmado(luminaria.hubPpalConfirmado)}}</td>

              <td *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">
                <div *ngIf="showGetHubsMap(luminaria)" style="align-items: center; display: flex; justify-content: center;">
                  <span (click)="sendGetHubsMap(luminaria.idDispositivo)" class="material-icons-outlined iconSend textXXM" style="cursor: pointer">arrow_right_alt</span>
                </div>
              </td>

              <td *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">
                <div style="align-items: center; display: flex; justify-content: center;">
                  <span *ngIf="!requestingPeripheralsByLuminariaId[luminaria.idDispositivo]"
                        (click)="sendGetPeripherals(luminaria.idDispositivo)"
                        class="material-icons-outlined iconSend textXXM" style="cursor: pointer">arrow_right_alt</span>
                  <mat-progress-spinner *ngIf="requestingPeripheralsByLuminariaId[luminaria.idDispositivo]"
                                        mode="indeterminate" diameter="18"></mat-progress-spinner>
                </div>
              </td>

              <td class="separator">{{luminaria.versionFirmware}}</td>
              <td class="separator">{{getLabelVersionConfirmada(luminaria.versionFirmwareConfirmada)}}</td>
              <td class="separator">{{luminaria.rssi}}</td>
              <td class="separator">{{luminaria.numSerie}}</td>
              <td class="separator">{{getDate(luminaria.fechaInstalacion * 1000)}}</td>

              <!-- Emergencies -->
              <td *ngIf="luminaria.perifericos != undefined && luminaria.perifericos.emg != -1 && luminaria.emergencias != null" class="separator">
                <div id="emergencyLed" class="emergency" [ngClass]="{'green': getLastEmergency(luminaria) == 0,
                      'red': getLastEmergency(luminaria) == 1, 'flashRed': getLastEmergency(luminaria) == 2}">
                </div>
              </td>
              <td *ngIf="luminaria.perifericos == undefined || luminaria.perifericos.emg == -1 || luminaria.emergencias == null" class="separator">--</td>

              <!-- Presence Sensor -->
              <td *ngIf="getTipoSensorLuminaria(luminaria) == 1 || getTipoSensorLuminaria(luminaria) == 2" class="separator">
                {{this.localiser.get("devices.yes")}}
              </td>
              <td *ngIf="getTipoSensorLuminaria(luminaria) != 1 && getTipoSensorLuminaria(luminaria) != 2" class="separator">
                {{this.localiser.get("devices.no")}}
              </td>

              <!-- 4-20mA Sensor -->
              <td *ngIf="getTipoSensorLuminaria(luminaria) == 0 || getTipoSensorLuminaria(luminaria) == 2" class="separator">
                {{this.localiser.get("devices.yes")}}
              </td>
              <td *ngIf="getTipoSensorLuminaria(luminaria) != 0 && getTipoSensorLuminaria(luminaria) != 2" class="separator">
                {{this.localiser.get("devices.no")}}
              </td>

              <td class="separator" *ngIf="luminaria.ledModelo == '0'">-</td>
              <td class="separator" *ngIf="luminaria.ledModelo != '0'">{{luminaria.ledModelo}}</td>
              <td class="separator">{{luminaria.nominalLux}}</td>
              <td *ngIf="user.getPermiso() != 'Ateneo' && luminaria.perifericos != undefined && luminaria.perifericos.dali != -1" class="separator">
                <button
                  (click)="seeDaliData(luminaria)"
                  class="seeDataButton"
                  [disabled]="!canSeeDaliData(luminaria)"
                  [ngClass]="{link: canSeeDaliData(luminaria)}">
                  {{this.localiser.get("devices.seeData")}}
                </button>
              </td>
              <td *ngIf="user.getPermiso() != 'Ateneo' && (luminaria.perifericos == undefined || luminaria.perifericos.dali == -1)"></td>
              <td *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator" style="width: 30px">
                <span class="material-icons-outlined textS+ verticalAlign" style="cursor: pointer"
                      (click)="deleteDevice('lum', luminaria)">delete</span>
              </td>
            </tr>
          </table>

          <!-- TABLE PERIPHERALS GRID VIEW -->
          <table style="width:100%; white-space: nowrap" *ngIf="gridView">
            <tr class="bottom-border fixHeaderTable">
              <th class="separator">{{this.localiser.get("devices.edit")}}</th>
              <th (click)="changeOrderLums('nombre', 'string')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.name")}}</span>
                  <span *ngIf="orderVariableLum[0] != 'nombre'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableLum[0] == 'nombre' && orderValueLum == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableLum[0] == 'nombre' && orderValueLum == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th matTooltip="{{this.localiser.get('peripherals.nvm')}}" [matTooltipPosition]="'above'" class="separator">nvm</th>
              <th matTooltip="{{this.localiser.get('peripherals.sst25')}}" [matTooltipPosition]="'above'" class="separator">sst25</th>
              <th matTooltip="{{this.localiser.get('peripherals.crypto_sw')}}" [matTooltipPosition]="'above'" class="separator">crypto_sw</th>
              <th matTooltip="{{this.localiser.get('peripherals.crypto_hw')}}" [matTooltipPosition]="'above'" class="separator">crypto_hw</th>
              <th matTooltip="{{this.localiser.get('peripherals.dali')}}" [matTooltipPosition]="'above'" class="separator">dali</th>
              <th matTooltip="{{this.localiser.get('peripherals.emg')}}" [matTooltipPosition]="'above'" class="separator">emg</th>
              <th matTooltip="{{this.localiser.get('peripherals.h420')}}" [matTooltipPosition]="'above'" class="separator">h420</th>
              <th matTooltip="{{this.localiser.get('peripherals.relay')}}" [matTooltipPosition]="'above'" class="separator">relay</th>
              <th matTooltip="{{this.localiser.get('peripherals.wdt')}}" [matTooltipPosition]="'above'" class="separator">wdt</th>
              <th matTooltip="{{this.localiser.get('peripherals.klc')}}" [matTooltipPosition]="'above'" class="separator">klc</th>
              <th matTooltip="{{this.localiser.get('peripherals.dfrobot')}}" [matTooltipPosition]="'above'" class="separator">dfrobot</th>
              <th matTooltip="{{this.localiser.get('peripherals.ekmc')}}" [matTooltipPosition]="'above'" class="separator">ekmc</th>
              <th matTooltip="{{this.localiser.get('peripherals.innosent')}}" [matTooltipPosition]="'above'" class="separator">innosent</th>
              <th matTooltip="{{this.localiser.get('peripherals.fc')}}" [matTooltipPosition]="'above'" class="separator">fc</th>
              <th *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">{{this.localiser.get("devices.peripherals.get")}}</th>
            </tr>
            <tr [ngClass]="{'luminariaSelected': selectedLuminariaByFloorplan != undefined && luminaria.idDispositivo == selectedLuminariaByFloorplan}"
                *ngFor="let luminaria of luminarias" style="text-align: center">
              <td class="separator">
                <span class="material-icons-outlined textXM verticalAlign" style="cursor: pointer"
                      (click)="editLuminaria(luminaria)">edit</span>
              </td>
              <td class="separator" style="text-align: left">{{luminaria.nombre}}</td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.nvm == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.nvm == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.nvm == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.sst25 == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.sst25 == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.sst25 == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.crypto_sw == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.crypto_sw == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.crypto_sw == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.crypto_hw == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.crypto_hw == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.crypto_hw == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.dali == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.dali == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.dali == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.emg == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.emg == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.emg == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.h420 == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.h420 == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.h420 == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.relay == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.relay == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.relay == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.wdt == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.wdt == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.wdt == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.klc == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.klc == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.klc == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.dfrobot == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.dfrobot == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.dfrobot == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.ekmc == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.ekmc == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.ekmc == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.innosent == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.innosent == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.innosent == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td class="separator">
                <span *ngIf="luminaria.perifericos == null || luminaria.perifericos.fc == -1" class="material-icons-outlined textM">horizontal_rule</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.fc == 0" class="material-icons-outlined textM">done</span>
                <span *ngIf="luminaria.perifericos != null && luminaria.perifericos.fc == 1" class="material-icons-outlined textM">warning</span>
              </td>
              <td *ngIf="user.getPermiso() != 'Ateneo' && user.getPermiso() != 'Configuración'" class="separator">
                <div style="align-items: center; display: flex; justify-content: center;">
                  <span *ngIf="!requestingPeripheralsByLuminariaId[luminaria.idDispositivo]"
                        (click)="sendGetPeripherals(luminaria.idDispositivo)"
                        class="material-icons-outlined iconSend textXXM" style="cursor: pointer">arrow_right_alt</span>
                  <mat-progress-spinner *ngIf="requestingPeripheralsByLuminariaId[luminaria.idDispositivo]"
                                        mode="indeterminate" diameter="18"></mat-progress-spinner>
                </div>
              </td>
            </tr>
          </table>

          <!-- LOADING SPINNER -->
          <div *ngIf="loadingLums && luminarias.length == 0">
            <mat-progress-spinner class="spinnerTable" mode="indeterminate" diameter="40"></mat-progress-spinner>
          </div>

          <!-- NO RESULTS TEXT -->
          <div *ngIf="!loadingLums && luminarias.length == 0" style="text-align: center">
            <h3 class="textXM" style="margin: 2vh auto">{{this.localiser.get('devices.noResults')}}</h3>
          </div>

        </div>
      </div>

      <!-- CONCENTRADORES -->
      <div *ngIf="user.getPermiso() != 'Ateneo'"  class="row deviceSection">

        <!-- FILTER GW -->
        <div class="col filterLuminariesDiv" *ngIf="concentradoresOpen">
          <span *ngIf="isAnyGWFilterSelected()" (click)="unselectAllGWFilters()" class="material-icons-outlined textXM centerVert cursorPointer unselectAllFilter">
            hide_source
          </span>
          <span *ngIf="!isAnyGWFilterSelected()" class="material-icons-outlined textXM centerVert unselectHideAllFilter">
            hide_source
          </span>
          <span (click)="openConcentradoresFilter()" *ngIf="!concentradoresFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            manage_search
          </span>
          <span (click)="openConcentradoresFilter()" *ngIf="concentradoresFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            close
          </span>
          <div *ngIf="concentradoresFilterOpen" class="filterLuminariesPanel">

            <!-- CHANNEL FILTER GW -->
            <div class="row rowFilterSelector" style="height: 25%">
              <div class="col-9">
                <h3 class="textS+ textFilterSelector">{{this.localiser.get('devices.channelFilter')}}</h3>
                <mat-select class="upperButton textS" (selectionChange)="selectChannelFilterGW($event.value)" [(ngModel)]="selectedChannelFilterGW">
                  <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
                  <mat-option class="textS" *ngFor="let channel of this.getChannelsByFilteredGW()"
                              [value]="channel">{{channel}}</mat-option>
                </mat-select>
              </div>
              <div class="col-3">
                <span *ngIf="selectedChannelFilterGW != undefined" (click)="selectChannelFilterGW(undefined) "class="material-icons-outlined textXM centerVert cursorPointer colorFilterSelector">
                  hide_source
                </span>
                <span *ngIf="selectedChannelFilterGW == undefined" class="material-icons-outlined textXM centerVert colorHideFilterSelector">
                  hide_source
                </span>
              </div>
            </div>

            <!-- VERSION FIRMWARE FILTER GW -->
            <div class="row rowFilterSelector" style="height: 25%">
              <div class="col-9">
                <h3 class="textS+ textFilterSelector">{{this.localiser.get('devices.firmwareVersionFilter')}}</h3>
                <mat-select class="upperButton textS" (selectionChange)="selectFirmwareVersionFilterGW($event.value)" [(ngModel)]="selectedFirmwareVersionFilterGW">
                  <mat-option class="textS" [value]="undefined">{{this.localiser.get('devices.all')}}</mat-option>
                  <mat-option class="textS" *ngFor="let fw of this.getFirmwareVersionByFilteredGW()"
                              [value]="fw">{{fw}}</mat-option>
                </mat-select>
              </div>
              <div class="col-3">
                <span *ngIf="selectedFirmwareVersionFilterGW != undefined" (click)="selectFirmwareVersionFilterGW(undefined) "class="material-icons-outlined textXM centerVert cursorPointer colorFilterSelector">
                  hide_source
                </span>
                <span *ngIf="selectedFirmwareVersionFilterGW == undefined" class="material-icons-outlined textXM centerVert colorHideFilterSelector">
                  hide_source
                </span>
              </div>
            </div>

            <!-- SELECT COMMUNICATING FILTER GW -->
            <div class="row rowFilterSelector">
              <div class="selectConcentradorDiv" *ngIf="concentradoresOpen">
                <div (click)="setCommunicatingFilterGW(true)" class="selectConc24h" [ngClass]="{ConcActive: selectedCommunicatingFilterGW}">
                  <h4 class="textS centerVert">{{this.localiser.get("devices.com24h")}}</h4>
                </div>
                <div (click)="setCommunicatingFilterGW(false)" class="selectConcTodos" [ngClass]="{ConcActive: !selectedCommunicatingFilterGW}">
                  <h4 class="textS+ centerVert">{{this.localiser.get("devices.all")}}</h4>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div (click)="openConcentradores()" class="deviceHeader" [ngClass]="{'headerCollapsed': !concentradoresOpen}">
          <h1 class="centerVert textXXM">{{this.localiser.get("devices.gateways")}}</h1>
        </div>
        <div class="deviceTable" *ngIf="concentradoresOpen">
          <table style="width:100%; white-space: nowrap">
            <tr class="bottom-border fixHeaderTable">
              <th class="separator"></th>
              <th class="separator">{{this.localiser.get("devices.edit")}}</th>
              <th class="separator">ID</th>
              <th (click)="changeOrderGW('nombre', 'string')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.name")}}</span>
                  <span *ngIf="orderVariableGW[0] != 'nombre'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableGW[0] == 'nombre' && orderValueGW == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableGW[0] == 'nombre' && orderValueGW == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th class="separator">{{this.localiser.get("devices.activestatus")}}</th>
              <th class="separator">{{this.localiser.get("devices.project")}}</th>
              <th class="separator">{{this.localiser.get("devices.floorplan")}}</th>
              <th class="separator">{{this.localiser.get("devices.zone")}}</th>
              <th (click)="changeOrderGW('lastCommunication', 'number')" class="separator cursorPointer">
                <div style="display: flex">
                  <span style="width: 100%; display: flex; align-items: center">{{this.localiser.get("devices.lastCommunication")}}</span>
                  <span *ngIf="orderVariableGW[0] != 'lastCommunication'" class="material-icons-outlined textM" style="cursor: pointer; opacity: 40%;">arrow_drop_down</span>
                  <span *ngIf="orderVariableGW[0] == 'lastCommunication' && orderValueGW == 1" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_up</span>
                  <span *ngIf="orderVariableGW[0] == 'lastCommunication' && orderValueGW == 2" class="material-icons-outlined textM" style="cursor: pointer">arrow_drop_down</span>
                </div>
              </th>
              <th class="separator">PAN ID</th>
              <th class="separator">{{this.localiser.get("devices.channel")}}</th>
              <th class="separator">{{this.localiser.get("devices.version")}}</th>
              <th class="separator">{{this.localiser.get("devices.otaGateway")}}</th>
              <th class="separator">{{this.localiser.get("devices.fechaInstalacion")}}</th>
              <!-- DELETE GW -->
              <th class="separator"></th>
            </tr>
            <tr *ngFor="let concentrador of concentradores">
              <td class="separator">
                <span *ngIf="isDuplicateGateway(concentrador)" class="material-icons-outlined textXM duplicateGatewayWarning">warning</span>
                <span *ngIf="!isDuplicateGateway(concentrador) && checkGatewayType(concentrador) == 'FF'" class="material-icons-outlined textXM">settings</span>
                <span *ngIf="!isDuplicateGateway(concentrador) && checkGatewayType(concentrador) != 'FF'" class="material-icons-outlined textXM">router</span>
              </td>
              <td class="separator">
                <span class="material-icons-outlined textXM" style="cursor: pointer"
                      (click)="editConcentrador(concentrador)">edit</span>
              </td>
              <td class="separator">{{concentrador.idDispositivo}}</td>
              <td class="separator" *ngIf="concentrador.nombre">
                {{concentrador.nombre}}
              </td>
              <td class="separator" *ngIf="!concentrador.nombre">
                --
              </td>
              <td class="separator">{{concentrador.activo ? this.localiser.get("devices.activestatus.active") : this.localiser.get("devices.activestatus.inactive")}}</td>
              <td class="separator" (click)="selectProyecto(getProyectoModelByIdProyecto(concentrador.idProyecto))"
                  [ngClass]="{link: this.getProyectoModelByIdProyecto(concentrador.idProyecto) != undefined}">
                {{getProyectoNombreByIdProyecto(concentrador.idProyecto)}}
              </td>
              <td class="separator" (click)="selectPlano(getPlanoModelById(concentrador.idPlano))"
                  [ngClass]="{link: this.getPlanoModelById(concentrador.idPlano) != undefined}">
                {{getPlanoNombreById(concentrador.idPlano)}}
              </td>
              <td class="separator" (click)="selectZona(getZonaModelById(concentrador.idZona))"
                  [ngClass]="{link: this.getZonaModelById(concentrador.idZona) != undefined}">
                {{getZonaNombreById(concentrador.idZona)}}
              </td>
              <td class="separator" *ngIf="concentrador.lastCommunication > 0">{{getDateAndHour(concentrador.lastCommunication)}}</td>
              <td class="separator" *ngIf="concentrador.lastCommunication <= 0">--</td>
              <td class="separator">{{concentrador.panId}}</td>
              <td class="separator">{{concentrador.channel}}</td>
              <td class="separator">{{concentrador.versionFirmware}}</td>
              <td class="separator">{{concentrador.concentradorMantenimiento}}</td>
              <td class="separator">{{getDateAndHour(concentrador.fechaInstalacion)}}</td>
              <td class="separator" style="width: 30px">
                <span class="material-icons-outlined textS+ verticalAlign" style="cursor: pointer"
                      (click)="deleteDevice('gw', concentrador)">delete</span>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- SENSORES -->
      <div class="row deviceSection">

        <!-- SEARCHER INPUT -->
        <div class="col searcherLuminariesDiv" *ngIf="sensoresOpen">
          <span class="material-icons-outlined textXXM centerVert searcherLuminariesIcon" style="color: white; width: 15%">
            search
          </span>
          <div class="searcherLuminariesControls">
            <input [(ngModel)]="searcherSensors" type="text" class="textS+ searcherInput"
                   placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherSensorsFunc()" maxlength="50">
          </div>
        </div>

        <!-- FILTER SENSORS -->
        <div class="col filterLuminariesDiv" *ngIf="sensoresOpen">

          <span (click)="openSensoresFilter()" *ngIf="!sensoresFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            manage_search
          </span>
          <span (click)="openSensoresFilter()" *ngIf="sensoresFilterOpen" class="material-icons-outlined textXXM centerVert cursorPointer colorFilterSelector">
            close
          </span>
          <div *ngIf="sensoresFilterOpen" class="filterLuminariesPanel">

            <div class="row rowFilterSelector" style="height: 20%">
              <h3 class="textM marginAuto">{{this.localiser.get('devices.sensorType')}}</h3>
            </div>

            <div class="row rowFilterSelector" style="height: 30%">
              <div class="col">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.all')}}</h3>
                </div>
                <div class="row marginAuto" style="height: 40%">
                  <mat-slide-toggle [disabled]="selectedAllFilterSensor" [checked]="selectedAllFilterSensor" (change)="setAllFilterSensor($event.checked)" class="marginAuto">
                    <h3 *ngIf="selectedAllFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selectedAllFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- TOGGLES FILTER LUMS -->
            <div class="row rowFilterSelector" style="height: 30%">

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">4-20 mA</h3>
                </div>
                <div class="row marginAuto" style="height: 40%">
                  <mat-slide-toggle [checked]="selected420FilterSensor" (change)="set420FilterSensor($event.checked)" class="marginAuto">
                    <h3 *ngIf="selected420FilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selected420FilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.presence')}}</h3>
                </div>
                <div class="row" style="height: 40%">
                  <mat-slide-toggle [checked]="selectedPresenceFilterSensor" (change)="setPresenceFilterSensor($event.checked)" class="marginAuto">
                    <h3 *ngIf="selectedPresenceFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selectedPresenceFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="col-4">
                <div class="row marginAuto" style="height: 60%">
                  <h3 class="textS+ marginAuto">{{this.localiser.get('devices.both')}}</h3>
                </div>
                <div class="row" style="height: 40%">
                  <mat-slide-toggle [checked]="selectedBothFilterSensor" (change)="setBothFilterSensor($event.checked)" class="marginAuto">
                    <h3 *ngIf="selectedBothFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.yes')}}</h3>
                    <h3 *ngIf="!selectedBothFilterSensor" class="textS+ marginAuto">{{this.localiser.get('devices.no')}}</h3>
                  </mat-slide-toggle>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- SENSORS TABLE -->
        <div (click)="openSensores()" class="deviceHeader" [ngClass]="{'headerCollapsed': !sensoresOpen}">
          <h1 class="centerVert textXXM">{{this.localiser.get("devices.sensors")}}</h1>
        </div>
        <div class="deviceTable" *ngIf="sensoresOpen">
          <table style="width:100%">
            <tr class="bottom-border fixHeaderTable">
              <th class="separator">{{this.localiser.get("devices.edit")}}</th>
              <th class="separator">ID</th>
              <th class="separator">{{this.localiser.get("devices.name")}}</th>
              <th class="separator">{{this.localiser.get("devices.project")}}</th>
              <th class="separator">{{this.localiser.get("devices.floorplan")}}</th>
              <th class="separator">{{this.localiser.get("devices.zone")}}</th>
              <th class="separator">{{this.localiser.get("devices.sensorType")}}</th>
              <th class="separator">{{this.localiser.get("devices.sensorData")}}</th>
              <!-- DELETE SENSOR -->
              <th class="separator"></th>
            </tr>
            <tr *ngFor="let sensor of sensores">
              <td class="separator">
                <span class="material-icons-outlined textXM" style="cursor: pointer"
                      (click)="editSensor(sensor)">edit</span>
              </td>
              <td class="separator">{{sensor.idLuminaria}}</td>
              <td class="separator" *ngIf="sensor.nombre">
              {{sensor.nombre}}
              </td>
              <td class="separator" *ngIf="!sensor.nombre">
                --
              </td>
              <td class="separator" (click)="selectProyecto(getProyectoModelByIdProyecto(sensor.idProyecto))"
                  [ngClass]="{link: this.getProyectoModelByIdProyecto(sensor.idProyecto) != undefined}">
                {{getProyectoNombreByIdProyecto(sensor.idProyecto)}}
              </td>
              <td class="separator" (click)="selectPlano(getPlanoModelById(sensor.idPlano))"
                  [ngClass]="{link: this.getPlanoModelById(sensor.idPlano) != undefined}">
                {{getPlanoNombreById(sensor.idPlano)}}
              </td>
              <td class="separator" class="separator" (click)="selectZona(getZonaModelById(sensor.idZona))"
                  [ngClass]="{link: this.getZonaModelById(sensor.idZona) != undefined}">
                {{getZonaNombreById(sensor.idZona)}}
              </td>
              <td class="separator">{{getTipoSensor(sensor.tipoSensor)}}</td>
              <td *ngIf="sensor.tipoSensor != 1" class="separator" (click)="seeSensorData(sensor)" class="link">
                <span>{{this.localiser.get("devices.seeData")}}</span>
              </td>
              <td *ngIf="sensor.tipoSensor == 1" class="separator">
              </td>
              <td class="separator" style="width: 30px">
                <span class="material-icons-outlined textS+ verticalAlign" style="cursor: pointer"
                      (click)="deleteDevice('sensor', sensor)">delete</span>
              </td>
            </tr>
          </table>
          <div *ngIf="user.getPermiso() != 'Ateneo'" style="text-align: center; margin: 2vh auto" (click)="goToLimits()" class="textS link">Define sensor limits</div>
        </div>
      </div>

    </div>

    <!-- DALI DATA -->
    <div *ngIf="showingDaliData">

      <div class="row deviceSection">
        <div (click)="goBackDaliData()" class="deviceHeader">
          <h1 class="centerVert textXXM">{{this.localiser.get("indicators.daliData")}} {{selectedLuminaria.nombre}}</h1>
        </div>
        <div class="deviceTable">
          <table style="width:100%">
            <tr>
              <th>ID</th>
              <th>{{this.localiser.get("devices.project")}}</th>
              <th>{{this.localiser.get("devices.floorplan")}}</th>
              <th>{{this.localiser.get("devices.zone")}}</th>
              <th>{{this.localiser.get("devices.version")}}</th>
              <th [matTooltip]="this.localiser.get('devices.versionConfirmedTooltip')"
                  [matTooltipPosition]="'above'">{{this.localiser.get("devices.versionConfirmed")}}</th>
              <th>{{this.localiser.get("devices.order")}}</th>
            </tr>
            <tr class="bottom-border">
              <td>{{selectedLuminaria.idDispositivo}}</td>
              <td>{{getProyectoNombreByIdProyecto(selectedLuminaria.idProyecto)}}</td>
              <td>{{getPlanoNombreById(selectedLuminaria.idPlano)}}</td>
              <td>{{getZonaNombreById(selectedLuminaria.idZona)}}</td>
              <td>{{selectedLuminaria.versionFirmware}}</td>
              <td>{{getLabelVersionConfirmada(selectedLuminaria.versionFirmwareConfirmada)}}</td>
              <td style="width: 15%">
                <mat-select class="orderSelectButton textS" (selectionChange)="changeOrderDaliData($event.value)" [(ngModel)]="orderDaliData">
                  <mat-option class="textS" [value]="false">{{this.localiser.get("devices.dateDesc")}}</mat-option>
                  <mat-option class="textS" [value]="true">{{this.localiser.get("devices.dateAsc")}}</mat-option>
                </mat-select>
              </td>
            </tr>
          </table>
        </div>
        <div class="deviceTableData">
          <table *ngIf="!loadingDaliDataTable && selectedLuminaria.daliDataList.length > 0" class="daliTable" style="width:100%">
            <tr class="bottom-border fixHeaderTable">
              <th matTooltip="{{this.localiser.get('dali.mac')}}" [matTooltipPosition]="'above'" class="vertLine">mac</th>
              <th matTooltip="{{this.localiser.get('dali.w')}}" [matTooltipPosition]="'above'" class="vertLine">w</th>
              <th matTooltip="{{this.localiser.get('dali.wh')}}" [matTooltipPosition]="'above'" class="vertLine">wh</th>
              <th matTooltip="{{this.localiser.get('dali.pcg')}}" [matTooltipPosition]="'above'" class="vertLine">pcg</th>
              <th matTooltip="{{this.localiser.get('dali.cg_ERR')}}" [matTooltipPosition]="'above'" class="vertLine">cg_ERR</th>
              <th matTooltip="{{this.localiser.get('dali.cg_UNDER_VOLTAGE')}}" [matTooltipPosition]="'above'" class="vertLine">cg_UNDER_VOLTAGE</th>
              <th matTooltip="{{this.localiser.get('dali.cg_OVER_VOLTAGE')}}" [matTooltipPosition]="'above'" class="vertLine">cg_OVER_VOLTAGE</th>
              <th matTooltip="{{this.localiser.get('dali.cg_POWER_LIMIT')}}" [matTooltipPosition]="'above'" class="vertLine">cg_POWER_LIMIT</th>
              <th matTooltip="{{this.localiser.get('dali.cg_DERATING_TEMP')}}" [matTooltipPosition]="'above'" class="vertLine">cg_DERATING_TEMP</th>
              <th matTooltip="{{this.localiser.get('dali.cg_SHUTDOWN_TEMP')}}" [matTooltipPosition]="'above'" class="vertLine">cg_SHUTDOWN_TEMP</th>
              <th matTooltip="{{this.localiser.get('dali.cg_TEMP')}}" [matTooltipPosition]="'above'" class="vertLine">cg_TEMP</th>
              <th matTooltip="{{this.localiser.get('dali.lg_ERR')}}" [matTooltipPosition]="'above'" class="vertLine">lg_ERR</th>
              <th matTooltip="{{this.localiser.get('dali.lg_SHORT_CIRCUIT')}}" [matTooltipPosition]="'above'" class="vertLine">lg_SHORT_CIRCUIT</th>
              <th matTooltip="{{this.localiser.get('dali.lg_OPEN_CIRCUIT')}}" [matTooltipPosition]="'above'" class="vertLine">lg_OPEN_CIRCUIT</th>
              <th matTooltip="{{this.localiser.get('dali.lg_DERATING_TEMP')}}" [matTooltipPosition]="'above'" class="vertLine">lg_DERATING_TEMP</th>
              <th matTooltip="{{this.localiser.get('dali.lg_SHUTDOWN_TEMP')}}" [matTooltipPosition]="'above'" class="vertLine">lg_SHUTDOWN_TEMP</th>
              <th matTooltip="{{this.localiser.get('dali.life_IN_HOURS')}}" [matTooltipPosition]="'above'" class="vertLine">life_IN_HOURS</th>
              <th matTooltip="{{this.localiser.get('dali.time_LAST_COM')}}" [matTooltipPosition]="'above'" class="vertLine">time_LAST_COM</th>
              <th matTooltip="{{this.localiser.get('dali.time_LAST_COM_II')}}" [matTooltipPosition]="'above'" class="vertLine">time_LAST_COM_II</th>
            </tr>
            <tr *ngFor="let data of selectedLuminaria.daliDataList" class="bottomBorderRow">
              <td class="vertLine">{{data.macluminaria}}</td>
              <td class="vertLine">{{data.w}}</td>
              <td class="vertLine">{{data.wh}}</td>
              <td class="vertLine">{{data.pcg}}</td>
              <td class="vertLine">{{data.cg_ERR}}</td>
              <td class="vertLine">{{data.cg_UNDER_VOLTAGE}}</td>
              <td class="vertLine">{{data.cg_OVER_VOLTAGE}}</td>
              <td class="vertLine">{{data.cg_POWER_LIMIT}}</td>
              <td class="vertLine">{{data.cg_DERATING_TEMP}}</td>
              <td class="vertLine">{{data.cg_SHUTDOWN_TEMP}}</td>
              <td class="vertLine">{{data.cg_TEMP}}</td>
              <td class="vertLine">{{data.lg_ERR}}</td>
              <td class="vertLine">{{data.lg_SHORT_CIRCUIT}}</td>
              <td class="vertLine">{{data.lg_OPEN_CIRCUIT}}</td>
              <td class="vertLine">{{data.lg_DERATING_TEMP}}</td>
              <td class="vertLine">{{data.lg_SHUTDOWN_TEMP}}</td>
              <td class="vertLine">{{data.life_IN_HOURS}}</td>
              <td class="vertLine">{{data.time_LAST_COM}}</td>
              <td class="vertLine">{{data.time_LAST_COM_II}}</td>
            </tr>
          </table>
          <div *ngIf="loadingDaliDataTable">
            <mat-progress-spinner class="spinnerTable" mode="indeterminate" diameter="40"></mat-progress-spinner>
          </div>
          <div *ngIf="!loadingDaliDataTable && selectedLuminaria.daliDataList.length == 0" style="text-align: center">
            <h3 class="textXM" style="margin: 2vh auto">{{this.localiser.get('devices.noData')}}</h3>
          </div>
        </div>
      </div>

      <div class="row daliDataBottomRow">
        <div class="daliDataActions">
          <button (click)="goBackDaliData()" class="backButton">
            <span class="material-icons-outlined textL">
            undo
            </span>
          </button>

          <button *ngIf="user.getPermiso() != 'Ateneo'" (click)="requestDaliData()" class="requestDaliButton textS+" [disabled]="requestingDaliData">
            <mat-progress-spinner *ngIf="requestingDaliData" diameter="20" mode="indeterminate" class="requestDaliSpinner"></mat-progress-spinner>
            <span>{{this.localiser.get(requestingDaliData ? "devices.daliData.requesting" : "devices.daliData.request")}}</span>
          </button>
        </div>

        <div class="paginationDivDaliData">
          <div class="row" style="width: 70%; display: contents">
            <div class="col" style="padding: 0">
              <span (click)="changeDaliDataPageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
                    [ngClass]="{disabledDaliData: actualDaliDataPage == 1}">
                navigate_before
              </span>
            </div>
            <div class="col" style="padding: 0">
              <input type="number" class="inputPaginationDaliData textXM centerVert" [(ngModel)]="this.actualDaliDataPage" (ngModelChange)="changeDaliDataPageByNumber($event)"
                     (change)="outInputChangeDaliDataPageByNumber($event)">
            </div>
            <div class="col" style="padding: 0">
              <span (click)="changeDaliDataPageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabledDaliData: isLastDaliDataPage()}">
                navigate_next
              </span>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- SENSOR DATA -->
    <div *ngIf="showingSensorData">

      <div class="row deviceSection">
        <div (click)="goBackDaliData()" class="deviceHeader">
          <h1 class="centerVert textXXM">{{this.localiser.get("devices.sensorDataTitle")}} {{selectedSensor.nombre}}</h1>
        </div>
        <div class="deviceTable">
          <table style="width:100%">
            <tr>
              <th>ID</th>
              <th>{{this.localiser.get("devices.project")}}</th>
              <th>{{this.localiser.get("devices.floorplan")}}</th>
              <th>{{this.localiser.get("devices.zone")}}</th>
              <th>{{this.localiser.get("devices.sensorType")}}</th>
              <th>{{this.localiser.get("devices.order")}}</th>
            </tr>
            <tr class="bottom-border">
              <td>{{selectedSensor.idLuminaria}}</td>
              <td (click)="selectProyecto(getProyectoModelByIdProyecto(selectedSensor.idProyecto))"
                  [ngClass]="{link: getProyectoNombreByIdProyecto(selectedSensor.idProyecto) != 'Sin asignar' ||
                  getProyectoNombreByIdProyecto(selectedSensor.idProyecto) != 'Unassigned'}">
                {{getProyectoNombreByIdProyecto(selectedSensor.idProyecto)}}
              </td>
              <td (click)="selectPlano(getPlanoModelById(selectedSensor.idPlano))"
                  [ngClass]="{link: getPlanoNombreById(selectedSensor.idPlano) != 'Sin asignar' ||
                  getProyectoNombreByIdProyecto(selectedSensor.idProyecto) != 'Unassigned'}">
                {{getPlanoNombreById(selectedSensor.idPlano)}}
              </td>
              <td class="separator" (click)="selectZona(getZonaModelById(selectedSensor.idZona))"
                  [ngClass]="{link: getZonaNombreById(selectedSensor.idZona) != 'Sin asignar' ||
                  getProyectoNombreByIdProyecto(selectedSensor.idProyecto) != 'Unassigned'}">
                {{getZonaNombreById(selectedSensor.idZona)}}
              </td>
              <td>{{selectedSensor.tipoSensor}}</td>
              <td style="width: 15%">
                <mat-select class="orderSelectButton textS" (selectionChange)="changeOrderSensorData($event.value)" [(ngModel)]="orderSensorData">
                  <mat-option class="textS" [value]="false">{{this.localiser.get("devices.dateDesc")}}</mat-option>
                  <mat-option class="textS" [value]="true">{{this.localiser.get("devices.dateAsc")}}</mat-option>
                </mat-select>
              </td>
            </tr>
          </table>
        </div>
        <div class="deviceTableData">
          <table *ngIf="sensorData.length > 0" class="daliTable" style="width:100%">
            <tr class="bottom-border fixHeaderTable">
              <th class="vertLine" *ngFor="let item of generateArray(sensorData[0])">{{item.key}}</th>
            </tr>
            <tr *ngFor="let data of sensorData">
              <td class="vertLine" *ngFor="let item of generateArray(data)">{{item.value}}</td>
            </tr>
          </table>
          <div *ngIf="sensorData.length == 0">
            <mat-progress-spinner class="spinnerTable" mode="indeterminate" diameter="40"></mat-progress-spinner>
          </div>
        </div>
      </div>

      <div class="row">
        <div style="position: absolute;">
          <button (click)="goBackDaliData()" class="backButton">
            <span class="material-icons-outlined textL">
            undo
            </span>
          </button>
        </div>

        <div class="paginationDivDaliData">
          <div class="row" style="width: 70%; display: contents">
            <div class="col" style="padding: 0">
              <span (click)="changeSensorDataPageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
                    [ngClass]="{disabledDaliData: actualSensorDataPage == 1}">
                navigate_before
              </span>
            </div>
            <div class="col" style="padding: 0">
              <input type="number" class="inputPaginationDaliData textXM centerVert" [(ngModel)]="this.actualSensorDataPage" (ngModelChange)="changeSensorDataPageByNumber($event)"
                     (change)="outInputChangeSensorDataPageByNumber($event)">
            </div>
            <div class="col" style="padding: 0">
              <span (click)="changeSensorDataPageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabledDaliData: isLastSensorDataPage()}">
                navigate_next
              </span>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>
